import { render } from "./DestinationList.vue?vue&type=template&id=239f2e2b"
import script from "./DestinationList.vue?vue&type=script&setup=true&lang=js"
export * from "./DestinationList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Destination/DestinationList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "239f2e2b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('239f2e2b', __exports__)) {
    api.reload('239f2e2b', __exports__)
  }
  
  module.hot.accept("./DestinationList.vue?vue&type=template&id=239f2e2b", () => {
    api.rerender('239f2e2b', render)
  })

}


export default __exports__